export const LIBRARY_IMAGE_ASSETS_REFRESH_EVENT = "library:image-assets-refresh";
